/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { isSmallScreen } from '../../utils/windowUtils';
import IntlCrawlableLink from '../IntlCrawlableLink';
import './styles.scss';

interface LoginButtonProps {}

class LoginButton extends Component<LoginButtonProps> {
  render() {
    const linkContent = isSmallScreen() ? (
      <i className="ui icon sign-in user-icon" />
    ) : (
      <FormattedMessage id="loginButton.buttonText" />
    );
    return (
      <IntlCrawlableLink url="/login" className="ui button login-button">
        {linkContent}
      </IntlCrawlableLink>
    );
  }
}

export default LoginButton;
